export default __webpack_public_path__ + "static/media/mongo.7a16fc61.png";